<template>
    <div class="sobre" id="sobre">
        <div class="container">
            <div class="row align-items-center">
                <div
                    class="col-12 col-lg-5 sobre__image-col wow animate__animated animate__fadeInLeft"
                >
                    <div class="sobre__image-frame">
                        <img
                            src="/img/dramonica_sobre.png"
                            alt="Dra. Mônica Irma"
                            class="sobre__photo"
                        />
                    </div>
                </div>
                <div
                    class="col-12 col-lg-6 offset-lg-1 sobre__text wow animate__animated animate__fadeInRight"
                >
                    <div class="sobre__label">
                        <span class="sobre__label-line"></span>
                        <span class="sobre__label-text">Sobre</span>
                    </div>
                    <h2 class="sobre__name">
                        Dra Mônica Irma<br>
                        <span class="sobre__name-full">Aparecida Valdeci de Souza</span>
                    </h2>
                    <h3 class="sobre__cro">CRO/SP 108965</h3>
                    <p class="sobre__bio">
                        Graduada em Odontologia pela UNESP - campus de Araraquara.
                        Possui título de mestra e doutora em Ciências Odontológicas pela UNESP.
                    </p>
                    <p class="sobre__bio">
                        Atua com excelência em estética reabilitadora e
                        restauradora, além de ser docente em cursos presenciais
                        e online de Estética e Odontopediatria.
                    </p>
                    <div class="sobre__credentials">
                        <div class="sobre__credential">
                            <span class="sobre__credential-number">UNESP</span>
                            <span class="sobre__credential-label">Formação</span>
                        </div>
                        <div class="sobre__credential">
                            <span class="sobre__credential-number">Mestre</span>
                            <span class="sobre__credential-label">Titulação</span>
                        </div>
                        <div class="sobre__credential">
                            <span class="sobre__credential-number">Doutora</span>
                            <span class="sobre__credential-label">Titulação</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style src="./style.scss" lang="scss" scoped/>
